import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SplashComponent } from './splash.component';

export const routes = [
  { path: '', component: SplashComponent, }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    RouterModule.forChild(routes)
  ],
  
})
export class SplashModule { }